import { Link } from "react-router-dom";

export const Logo = ({ size = "h-9" }) => (
  <Link to="/" data-testid="brand-logo-link" className="flex items-center gap-3 group">
    <span className="bg-white rounded-xl px-2 py-1 shadow-[0_0_18px_rgba(183,255,60,0.15)] border border-[#B7FF3C]/30 transition-transform duration-300 group-hover:scale-[1.03]">
      <img src="/logo.png" alt="CricAnalyze" className={`${size} w-auto object-contain`} />
    </span>
  </Link>
);
